import requestJWT from "utils/requestJWT";
import request from "utils/request";

const getAllByAdminApi = async (query, category, page) => {
    return await requestJWT.get(`/news/get-by-admin?query=${query}&page=${page}&item=5&category=${category}`);
};

const getNewsByCategoryApi = async (slug, page) => {
    return await request.get(`/news/${slug}/get-by-category?page=${page}&item=5`);
};

const getNewsDetailApi = async (slug) => {
    return await request.get(`/news/get-by-slug/${slug}`);
};


const createApi = async (data) => {
    return await requestJWT.post(`/news/create`, data);
};

const updateApi = async (id, data) => {
    return await requestJWT.put(`/news/${id}/update`, data);
};

const deleteApi = async (id) => {
    return await requestJWT.delete(`/news/${id}/remove`);
};

export {
    getAllByAdminApi,
    createApi,
    updateApi,
    deleteApi,
    getNewsByCategoryApi,
    getNewsDetailApi
};
